import { mapGetters } from 'vuex'

import Configuration from '@/agilis/util/Configuration'
import DataTableV2Paginated from '@/agilis/components/DataTableV2Paginated/DataTableV2Paginated.vue'
import TabsComponent from '@/agilis/components/Tabs/Tabs.vue'

export default {
  name: 'ReportTabs',

  components: {
    DataTableV2Paginated,
    TabsComponent
  },

  computed: {
    ...mapGetters({
      applicationId: 'contextStore/applicationId',
      workspaceId: 'contextStore/workspaceId'
    }),

    reports () {
      const authReports = Configuration.auth.getReportIds(this.applicationId, this.workspaceId)
      const reports = Configuration.getApplication(this.applicationId).reports
      return Object.keys(reports)
        .filter((key) => authReports.includes(key))
        .reduce((report, key) => { return Object.assign(report, { [key]: reports[key] }) }, {})
    },

    tabs () {
      return Object.keys(this.reports)
    }
  },

  methods: {
    reportDatatable (reportId) {
      return this.reports[reportId].dataTable
    },

    reportTitle (reportId) {
      return this.$t(this.reports[reportId].name)
    },

    reportDescription (reportId) {
      return this.$t(this.reports[reportId].description)
    }
  }
}
